"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changePasswordRequest = exports.updateMemberRequest = exports.addMemberRequest = exports.memberDto = exports.rolesResponse = exports.customRoleDto = exports.upsertCustomRoleRequest = exports.assignablePermission = exports.ASSIGNABLE_PERMISSIONS = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const auth_1 = require("./auth");
const company_1 = require("./company");
// ---------------------------------------------------------------------------
// الأدوار المخصصة والمستخدمون (ADR-0006)
// ---------------------------------------------------------------------------
/**
 * الصلاحيات التى تُمنح فى دور مخصص — كلها عدا `user.manage`: إدارة المستخدمين والأدوار
 * للمالك وحده، وإلا صنع صاحب الدور المخصص لنفسه دورًا أعلى.
 */
exports.ASSIGNABLE_PERMISSIONS = auth_1.permissionName.options.filter((permission) => permission !== 'user.manage');
exports.assignablePermission = auth_1.permissionName.refine((permission) => permission !== 'user.manage', 'user.manage is owner-only and cannot be granted by a custom role');
exports.upsertCustomRoleRequest = zod_1.z
    .object({
    nameAr: zod_1.z.string().trim().min(1).max(100),
    permissions: zod_1.z
        .array(exports.assignablePermission)
        .min(1)
        .refine((list) => new Set(list).size === list.length, 'duplicate permission')
        // القراءة حد أدنى لأى عضوية — دور بلا قراءة لا يرى شيئًا يعمل عليه
        .refine((list) => list.includes('company.read'), 'company.read is required'),
})
    .strict();
exports.customRoleDto = zod_1.z.object({
    id: common_1.uuid,
    nameAr: zod_1.z.string(),
    permissions: zod_1.z.array(auth_1.permissionName),
    memberCount: zod_1.z.number().int(),
});
exports.rolesResponse = zod_1.z.object({
    builtIn: zod_1.z.array(zod_1.z.object({ role: company_1.roleName, permissions: zod_1.z.array(auth_1.permissionName) })),
    custom: zod_1.z.array(exports.customRoleDto),
    assignable: zod_1.z.array(auth_1.permissionName),
});
exports.memberDto = zod_1.z.object({
    userId: common_1.uuid,
    email: zod_1.z.string(),
    displayName: zod_1.z.string(),
    role: company_1.roleName,
    customRoleId: common_1.uuid.nullable(),
    customRoleName: zod_1.z.string().nullable(),
    /** الصلاحيات الفاعلة بعد الدور المخصص. */
    permissions: zod_1.z.array(auth_1.permissionName),
    isActive: zod_1.z.boolean(),
    mfaEnrolled: zod_1.z.boolean(),
});
const roleAssignment = {
    role: company_1.roleName,
    customRoleId: common_1.uuid.nullable().default(null),
};
const ownerHasNoCustomRole = (value) => !(value.role === 'owner' && value.customRoleId !== null);
/**
 * إضافة عضو: بريد جديد يُنشأ له حساب بكلمة سر أولى يحددها المالك ويغيّرها المستخدم
 * بعد دخوله، وبريد لمستخدم قائم فى نفس المستأجر يُضاف للشركة بلا كلمة سر.
 */
exports.addMemberRequest = zod_1.z
    .object({
    email: auth_1.email,
    displayName: zod_1.z.string().trim().min(1).max(200),
    password: auth_1.password.optional(),
    ...roleAssignment,
})
    .strict()
    .refine(ownerHasNoCustomRole, {
    message: 'owner cannot have a custom role',
    path: ['customRoleId'],
});
exports.updateMemberRequest = zod_1.z
    .object(roleAssignment)
    .strict()
    .refine(ownerHasNoCustomRole, {
    message: 'owner cannot have a custom role',
    path: ['customRoleId'],
});
exports.changePasswordRequest = zod_1.z
    .object({
    currentPassword: zod_1.z.string().min(1).max(256),
    newPassword: auth_1.password,
})
    .strict();
//# sourceMappingURL=members.js.map